export const sources = {
	avif: "__VITE_ASSET__B6CGXDDu__ 500w, __VITE_ASSET__CA5gmnHx__ 632w",
	webp: "__VITE_ASSET__CjBoO0AV__ 500w, __VITE_ASSET__BXzfxjRe__ 632w",
	jpeg: "__VITE_ASSET__Csl47Xi6__ 500w, __VITE_ASSET__BZXokIxO__ 632w"
};
export const img = {
	src: "__VITE_ASSET__BZXokIxO__",
	w: 632,
	h: 799
};
export default {
	sources: sources,
	img: img
};
